import type { ReactNode } from 'react';
import { Monitor, Paper, Scanner, artStyle } from './parts';

/** Scanning from the browser: the scanner beside the computer, the page on its way into Paige on screen. */
export function ScanArt({ width = 280 }: { width?: number }): ReactNode {
  return (
    <svg
      className="scan-art"
      viewBox="0 0 280 180"
      style={artStyle(width)}
      aria-hidden="true"
      focusable="false"
    >
      <Monitor x={10} y={34}>
        <path className="sa-ink" d="M16 18h4M24 18h4M32 18h4" />
        <path className="sa-ink" d="M44 18h60" opacity="0.5" />
        <Paper x={44} y={28} w={34} h={44} mark />
      </Monitor>
      <path className="sa-trail" d="M168 112 C 156 80, 150 74, 120 84" />
      <Paper x={142} y={72} r={-14} w={18} h={23} tone={2} lines={false} className="sa-float" />
      <Scanner x={170} y={46} />
    </svg>
  );
}
